import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { PreContractRequest } from '../model/contract.model'

export interface ContractItemState {
  errorMessage: string
  errorCode: string
  data: [] | null
  httpStatus: number | null
}

export interface ContractState {
  preContract: ContractItemState
}

interface createPreContractRequest {
  body: PreContractRequest
  tenant: string
}

interface createPreContractResponse {
  errorMessage?: string
  errorCode?: string
  data?: [] | null
  httpStatus?: number
}

export const initialState: ContractState = {
  preContract: {
    errorMessage: '',
    errorCode: '',
    data: null,
    httpStatus: null,
  },
}

const contractSlice = createSlice({
  name: 'contract',
  initialState,
  reducers: {
    createPreContract: (state, _action: PayloadAction<createPreContractRequest>) => {
      return {
        ...state,
        preContract: {
          ...initialState.preContract,
        },
      }
    },
    createPreContractSuccess: (state, action: PayloadAction<createPreContractResponse>) => {
      return {
        ...state,
        preContract: {
          ...initialState.preContract,
          ...action.payload,
        },
      }
    },
    createPreContractError: (state, action: PayloadAction<createPreContractResponse>) => {
      return {
        ...state,
        preContract: {
          ...initialState.preContract,
          ...action.payload,
        },
      }
    },
    resetContract: () => initialState,
  },
})

export const {
  createPreContract,
  createPreContractSuccess,
  createPreContractError,
  resetContract,
} = contractSlice.actions

const contractReducer = contractSlice.reducer

export default contractReducer
